import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-popmsg',
  templateUrl: './popmsg.component.html',
  styleUrls: ['./popmsg.component.scss']
})
export class PopmsgComponent implements OnInit {
 @Input() msg;@Input() msg2;
  constructor(public modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
